    <div (click)="profileMenu.toggle($event)"
         class="hover:shadow-sm hover:shadow-gray-400 hover:cursor-pointer hover:scale-110 hover:transition-all
                rounded-full w-8 h-8 transition-all duration-400
                bg-blue-600 text-white font-semibold
                flex items-center justify-center text-sm">
      {{ userInitials() }}
    </div>

    <p-popover #profileMenu>
        <div class="w-56">
            <div class="flex flex-col gap-1">
                <span class="font-medium truncate">{{userName()}}</span>
                <span class="text-gray-500 truncate">{{userEmail()}}</span>
            </div>
            <p-divider />
            <ul class="m-[-12px]">
                <li class="px-4 py-2 hover:bg-gray-100 hover:cursor-pointer" (click)="goToProfile()">
                    <a>
                        <i class="pi pi-user"></i>
                        <span class="ml-2">Mi Perfil</span>
                    </a>
                </li>
                <li class="px-4 py-2 hover:bg-gray-100 hover:cursor-pointer" (click)="goToHome()">
                    <a>
                        <i class="pi pi-home"></i>
                        <span class="ml-2">Inicio</span>
                    </a>
                </li>
                <li *appHasAction="ACTIONS.VIEW_SETTINGS" class="px-4 py-2 hover:bg-gray-100 hover:cursor-pointer" (click)="goToSettings()">
                    <a>
                        <i class="pi pi-cog"></i>
                        <span class="ml-2">Configuración</span>
                    </a>
                </li>
                <li class="px-2">
                    <p-divider />
                </li>
                <li class="px-4 py-2 hover:bg-gray-100 hover:cursor-pointer" (click)="logout()">
                    <a>
                        <i class="pi pi-sign-out"></i>
                        <span class="ml-2">Cerrar Sesión</span>
                    </a>
                </li>
            </ul>
        </div>
    </p-popover>
